module.exports = ".row{\r\n    margin-top:4px;\r\n    padding:2px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/project-master/projectmaster-form/projectmaster-form.component.css
// module id = ./src/app/master/project-master/projectmaster-form/projectmaster-form.component.css
// module chunks = main